import React, { useCallback, useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { colors } from '@styleseat/brand';
import { useLinkTo } from '../../../../hooks';
import withStore from '../../../withStore';

import NotificationBanner from '../NotificationBanner';
import SmartPricingAnnouncementModal from '../../smartPricing/SmartPricingAnnouncementModal';
import analytics from '../../../../modules/analytics';

const FirstSPClientApptBookingNotification = ({ notification }) => {
  const {
    local_start: localStart,
    client_name: clientName,
    service_name: serviceName,
  } = notification;

  const [showModal, setShowModal] = useState(false);

  const linkTo = useLinkTo();
  const highlightedText = `${clientName} booked ${serviceName}`;
  const text = `for ${moment.utc(localStart).format('dddd, MMM D')}\xa0at\xa0${moment.utc(localStart).format('h:mm A')}`;
  const highlightedSubText = 'This is your first smart priced appointment!';
  const subText = 'We helped you book this popular time for 20% more.';

  const isNCD = notification?.is_new_client_delivery;
  const isSmartPrice = notification?.is_smart_price;
  const isUserFirstTimeBookingWithPro = notification?.is_user_first_time_booking_with_pro;

  const showSmartPricing = !isNCD && isSmartPrice;

  let badgeAppearance;

  if (isNCD) {
    badgeAppearance = 'square punch';
  } else if (showSmartPricing) {
    badgeAppearance = 'square purple';
  }

  const goToApptDetails = () => {
    linkTo(
      'provider.appointment',
      { viewApptId: notification.appointment_id },
      true, // Notify: true
    );
  };

  const handleTextLinkClick = useCallback(
    () => {
      analytics.track('pro_notification_first_smart_pricing_learn_more_clicked');
      setShowModal(true);
    }, [showModal],
  );

  const handleCloseModal = useCallback(
    () => {
      setShowModal(false);
    }, [showModal],
  );

  const textLinkProps = {
    text: 'Learn more about Smart Pricing',
    onClick: handleTextLinkClick,
    appearance: 'small',
    weight: 'bold',
    stopPropagation: true,
  };

  return (
    <React.Fragment>
      <NotificationBanner
        notification={notification}
        highlightedText={highlightedText}
        text={text}
        highlightedSubText={highlightedSubText}
        subText={subText}
        textLinkProps={textLinkProps}
        highlightBorderColor={colors.purple}
        handleNotificationClick={goToApptDetails}
        avatarIconBorderColor={showSmartPricing ? colors.purple : null}
        avatarBadgeAppearance={badgeAppearance}
        avatarBadgeText={isUserFirstTimeBookingWithPro ? 'New' : null}
        showAvatarIcon
      />
      {showModal && (
        <SmartPricingAnnouncementModal
          onClose={handleCloseModal}
        />
      )}
    </React.Fragment>
  );
};

FirstSPClientApptBookingNotification.propTypes = {
  notification: PropTypes.object.isRequired,
};

export default withStore(FirstSPClientApptBookingNotification);
